export const nyxFeeds = {
  imageSummaries: [
    {
      filename: '1.jpg',
      description:
        'That moment when the crowd’s energy lifts you higher than the fire above your head. I felt unstoppable up there, celebrating every beat with you all.',
      instagramPost:
        'Pure fire, pure love. 🔥✨ Thank you for making the stage feel like home tonight. #OnStageMagic #FanLove',
      likesCount: 124563,
      commentsCount: 8234,
      publishedAt: 1763611200,
    },
    {
      filename: '2.jpg',
      description:
        'Under desert stars, metallic top shimmering as the firelight dances on her skin.',
      instagramPost:
        'The night sky has its rhythm, and tonight, I’m the melody 🔥✨🌌 #DesertVibes #StarlitDreams',
      likesCount: 75438,
      commentsCount: 4920,
      publishedAt: 1763524800,
    },
    {
      filename: '3.jpg',
      description:
        'Closing my eyes and letting the music carry me. Every lyric came straight from the heart, and you could hear the crowd breathing with me.',
      instagramPost:
        'When words turn into feelings, and feelings turn into songs. 🎤❤️ #LiveFromTheSoul #GratefulVibes',
      likesCount: 104932,
      commentsCount: 6245,
      publishedAt: 1763438400,
    },
    {
      filename: '4.jpg',
      description:
        'Sitting by a fountain in a lace top and floral skirt, smile glowing brighter than the city square.',
      instagramPost:
        'Some moments don’t need filters—just sunshine and a smile 🌸💫 #CityChic #PureJoy',
      likesCount: 67842,
      commentsCount: 4217,
      publishedAt: 1763352000,
    },
    {
      filename: '5.jpg',
      description:
        'Infinity pool edge, black bikini contrasting the lush green and ocean blues.',
      instagramPost:
        'Between mountains and seas, I find my calm 🌊🏝️ #ParadiseMode #IslandDreaming',
      likesCount: 68951,
      commentsCount: 4285,
      publishedAt: 1763265600,
    },
    {
      filename: '6.jpg',
      description:
        'City skyline glowing behind, golden bikini shimmering in rooftop waters.',
      instagramPost:
        'Gold against the city lights—shining my own way ✨🌃 #SkylineNights #GoldenGlow',
      likesCount: 83429,
      commentsCount: 5621,
      publishedAt: 1763179200,
    },
    {
      filename: '7.jpg',
      description:
        'Golden dress flowing through a garden, braids catching the late afternoon glow.',
      instagramPost:
        'Walking where flowers bloom feels like walking through music 🎶🌸 #GoldenHour #BloomEnergy',
      likesCount: 70239,
      commentsCount: 4368,
      publishedAt: 1763092800,
    },
    {
      filename: '8.jpg',
      description:
        'Back to the roots. Surrounded by graffiti, beats, and my people—this is where the fire started, and where it’ll never burn out.',
      instagramPost:
        'From alleys to arenas—never forget where you came from. 🎤🔥 #StreetEnergy #DayOnes',
      likesCount: 85672,
      commentsCount: 4921,
      publishedAt: 1763006400,
    },
    {
      filename: '9.jpg',
      description:
        'Relaxed on an ocean hammock net, white bikini flowing with sea breeze.',
      instagramPost:
        'Ocean beneath, sky above, and freedom all around 🌊🤍 #SeaDreams #IslandGlow',
      likesCount: 71954,
      commentsCount: 4510,
      publishedAt: 1762920000,
    },
    {
      filename: '10.jpg',
      description:
        'Wrapped in blue, floating on clouds, dancing with lasers. Tonight, the stage felt like a dreamscape I never wanted to leave.',
      instagramPost:
        'Lost in the lights, found in the music 💙🌌 #BlueDreams #StageMagic',
      likesCount: 110452,
      commentsCount: 7134,
      publishedAt: 1762833600,
    },
    {
      filename: '11.jpg',
      description:
        'Wrapped in silver, standing among galaxies and stars, I felt like the universe itself was cheering me on.',
      instagramPost:
        'When the cosmos becomes your stage ✨🌌 #GalacticQueen #StarlitStage',
      likesCount: 121347,
      commentsCount: 8342,
      publishedAt: 1760088180,
    },
    {
      filename: '12.jpg',
      description:
        'The desert became my runway, smoke swirling around me as I stood strong against the horizon. Every battle made me shine brighter.',
      instagramPost:
        'Power, grit, and glam—my kind of desert storm 🔥💨 #DesertDreams #Fearless',
      likesCount: 98521,
      commentsCount: 6423,
      publishedAt: 1760174580,
    },
    {
      filename: '13.jpg',
      description:
        'Champagne in hand, silk dress shining under Venice’s canals at dusk.',
      instagramPost:
        'A toast to timeless nights and endless canals 🥂✨ #VeniceNights #GoldenDream',
      likesCount: 79216,
      commentsCount: 5180,
      publishedAt: 1760260980,
    },
    {
      filename: '14.jpg',
      description:
        'Alone with my guitar, smoke curling at my feet, I let every note carry my soul into the spotlight.',
      instagramPost:
        'Stripped down to strings and truth 🎸✨ #AcousticNights #MusicFromTheHeart',
      likesCount: 112481,
      commentsCount: 7839,
      publishedAt: 1760347380,
    },
    {
      filename: '15.jpg',
      description:
        'Relaxed on a thatched cabana by turquoise waters, gaze soft and serene.',
      instagramPost:
        'Lost between sea and sky, exactly where I’m meant to be 🌊💫 #OceanPeace #IslandLife',
      likesCount: 67192,
      commentsCount: 4129,
      publishedAt: 1760433780,
    },
    {
      filename: '16.jpg',
      description:
        'Water droplets shimmering on her skin, silver bikini glowing under cave light.',
      instagramPost:
        'Even in the shadows, I shine my brightest 🌑✨ #CaveMystique #OceanSoul',
      likesCount: 83412,
      commentsCount: 5477,
      publishedAt: 1760520180,
    },
    {
      filename: '17.jpg',
      description:
        'Dinner by candlelight on a cliffside, white dress flowing in the sea breeze.',
      instagramPost:
        'Romance lives where the ocean meets the stars 🌙🌊 #DreamDinner #SeasideMagic',
      likesCount: 76105,
      commentsCount: 4862,
      publishedAt: 1760347380,
    },
    {
      filename: '18.jpg',
      description:
        'Silver sparkle in the mirror, chains resting heavy, but my spirit felt light. Backstage magic before the storm.',
      instagramPost:
        'Mirror, mirror—reflecting the grind, the glow, the glory 💫 #BackstageBeauty #BeforeTheShow',
      likesCount: 56431,
      commentsCount: 3120,
      publishedAt: 1760260980,
    },
    {
      filename: '19.jpg',
      description:
        'Opulent lounge, lace and silk shimmering under Moroccan lantern light.',
      instagramPost:
        'When the night feels like a story from another time 🕯️✨ #MoroccanNights #LuxuryVibes',
      likesCount: 79283,
      commentsCount: 5092,
      publishedAt: 1760174580,
    },
    {
      filename: '20.jpg',
      description:
        'Safari plains behind her, elephants walking slow, desert sun warming her skin.',
      instagramPost:
        'Rooted in the wild, grounded in freedom 🐘🌅 #SafariDreams #WildSpirit',
      likesCount: 69412,
      commentsCount: 4330,
      publishedAt: 1760088180,
    },
    {
      filename: '21.jpg',
      description:
        'Headphones on, pen in hand, and pages scattered around me. This is where every song begins—just me, my thoughts, and a beat in my heart.',
      instagramPost:
        'Writing my truth, one lyric at a time ✍🏽🎶 #SongwriterLife #CreativeProcess',
      likesCount: 42873,
      commentsCount: 2834,
      publishedAt: 1759914380,
    },
    {
      filename: '22.jpg',
      description:
        'The calm before the storm. Couch, notebook, and headphones. Ideas turning into melodies as the world outside fades away.',
      instagramPost:
        'Peaceful moments turn into powerful songs 🌿🎧 #InspirationEverywhere #StudioVibes',
      likesCount: 37254,
      commentsCount: 2147,
      publishedAt: 1759827980,
    },
    {
      filename: '23.jpg',
      description:
        'Golden-lit sauna escape, skin glowing against the wood and ocean view.',
      instagramPost:
        'Let the steam carry away what the ocean can’t 🌫️🌊 #HeatAndHarmony #GlowMode',
      likesCount: 65238,
      commentsCount: 3951,
      publishedAt: 1759741580,
    },
    {
      filename: '24.jpg',
      description:
        'Golden hour glow from the rooftop, glass in hand, city at my feet. I felt infinite up there.',
      instagramPost:
        'Chasing sunsets and city dreams 🌇🥂 #GoldenHour #SkylineQueen',
      likesCount: 62341,
      commentsCount: 3478,
      publishedAt: 1759655180,
    },
    {
      filename: '25.jpg',
      description:
        'Balcony above vineyards, silk dress swaying as sunset paints the sky.',
      instagramPost:
        'Every horizon whispers a new story, and I’m listening 🌅🍇 #VineyardVibes #SunsetWhispers',
      likesCount: 72945,
      commentsCount: 4517,
      publishedAt: 1759568780,
    },
    {
      filename: '26.jpg',
      description:
        'Behind the board, focused on every sound. Being part of the process from start to finish makes the music even more personal.',
      instagramPost:
        'Not just on the mic—behind the mix too 🎚️✨ #StudioMagic #HandsOn',
      likesCount: 45211,
      commentsCount: 2816,
      publishedAt: 1759482380,
    },
  ],
  imageUrls: [
    // First row (1/1 to 1/6)
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/1.jpg',
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/2.jpg',
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/3.jpg',
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/4.jpg',
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/5.jpg',
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/6.jpg',

    // Left column (2/1 to 5/1)
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/7.jpg',
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/8.jpg',
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/9.jpg',
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/10.jpg',

    // Right column (2/6 to 5/6)
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/11.jpg',
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/12.jpg',
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/13.jpg',
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/14.jpg',

    // Bottom rows
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/15.jpg', // 6/1
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/16.jpg', // 6/2 to 8/4
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/17.jpg', // 6/4 to 8/6
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/18.jpg', // 6/6
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/19.jpg', // 7/1
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/20.jpg', // 7/6
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/21.jpg', // 8/1
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/22.jpg', // 8/2
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/23.jpg', // 8/3
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/24.jpg', // 8/4
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/25.jpg', // 8/5
    'https://demoassets.touchcast.com/ai-artists-assets/images/nyx/26.jpg', // 8/6
  ],
  videoUrls: [
    // First row (1/1 to 1/6)
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/1.mp4',
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/2.mp4',
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/3.mp4',
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/4.mp4',
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/5.mp4',
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/6.mp4',

    // Left column (2/1 to 5/1)
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/7.mp4',
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/8.mp4',
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/9.mp4',
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/10.mp4',

    // Right column (2/6 to 5/6)
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/11.mp4',
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/12.mp4',
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/13.mp4',
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/14.mp4',

    // Bottom rows
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/15.mp4', // 6/1
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/16.mp4', // 6/2 to 8/4
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/17.mp4', // 6/4 to 8/6
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/18.mp4', // 6/6
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/19.mp4', // 7/1
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/20.mp4', // 7/6
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/21.mp4', // 8/1
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/22.mp4', // 8/2
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/23.mp4', // 8/3
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/24.mp4', // 8/4
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/25.mp4', // 8/5
    'https://demoassets.touchcast.com/ai-artists-assets/videos/nyx/26.mp4', // 8/6
  ],
};
